import { ProfileItem } from "PFApp/components/profile_item";
import { buildProfilesOptionsFetcher } from "PFApp/helpers/options/profiles_options";
import { Select, SelectCommonProps } from "PFComponents/select";
import { BasicProfile, Id } from "PFCore/types";
import { Option } from "PFTypes/options";

type AssigneeSelectorProps = Omit<
  SelectCommonProps<BasicProfile>,
  "onChange" | "onClear" | "renderDisplayValue"
> & {
  value?: Id;
  onChange: (value: Id | null) => void;
};

export const AssigneeSelector = ({
  value,
  onChange,
  required,
  ref,
  ...selectProps
}: AssigneeSelectorProps) => (
  <Select<BasicProfile>
    inputRef={ref}
    dropdownWidth={300}
    {...selectProps}
    value={value}
    required={required}
    fetchOptions={buildProfilesOptionsFetcher({ policyName: "resourcer", profileVisibility: "active" })}
    onChange={(value: Option<BasicProfile>) => onChange(value.original.id)}
    onClear={!required && value ? () => onChange(null) : undefined}
    renderDisplayValue={(option: Option<BasicProfile>) =>
      option?.original ? <ProfileItem profile={option.original} splitInfo /> : null
    }
  />
);
